<template>
  <form
    id="signin"
    name="signInForm"
    class="crud-form"
    v-on:submit.prevent="signIn">
    <h4 class="text-secondary">
      Please sign in
      <hr class="mt-2 mb-0">
    </h4>

    <!-- Username -->
    <label for="username">Username:</label>
    <b-form-input
      id="username"
      class="mb-2"
      type="text"
      size="sm"
      name="username"
      placeholder="Enter your username"
      v-model="credentials.Username"
    />
    <!-- / Username -->

    <!-- Password -->
    <label for="password">Password:</label>
    <b-form-input
      id="password"
      type="password"
      size="sm"
      name="password"
      placeholder="Enter your password"
      v-model="credentials.Password"
    />
    <!-- / Password -->

    <div class="d-flex flex-row align-items-center justify-content-between mt-4">
      <!-- Keep Signed In -->
      <b-form-checkbox
        id="keepSignedIn"
        class="mr-0"
        v-model="keepSignedIn">
        Keep me signed in
      </b-form-checkbox>
      <!-- / Keep Signed In -->

      <!-- Submit -->
      <b-button
        type="submit"
        size="sm"
        variant="success">
        Sign In
      </b-button>
      <!-- / Submit -->
    </div>
  </form>
</template>

<script>
import DataSvc from '../services/data';
import { GlobalLoaderMixin } from '../services/event-bus';
import { SessionMixin, Session } from '../services/user-session';

export default {
  name: 'signin',
  mixins: [
    GlobalLoaderMixin,
    SessionMixin,
  ],
  data() {
    return {
      keepSignedIn: true,
      credentials: {
        Username: process.env.VUE_APP_AUTO_LOGIN_USERNAME,
        Password: process.env.VUE_APP_AUTO_LOGIN_PASSWORD,
      },
    };
  },
  methods: {
    signIn() {
      this.showGlobalLoader('Authorizing...');

      return DataSvc.signIn(this.credentials)
        .then((user) => {
          this.$router.replace({ name: 'list-customers' });
          this.user = user;
          Session.begin(user, this.keepSignedIn);
        })
        .finally(() => {
          this.hideGlobalLoader();
        });
    },
  },
};
</script>

<style lang="scss">
#signin {
  max-width: 300px;
  margin: auto;
  margin-top: 200px;
}
</style>
